import styled from "styled-components";

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const NotFoundTextCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 500px;
  z-index: 4;
  position: absolute;
`;

export const NotFoundButton = styled.div`
  padding: 24px;
  min-width: 55%;
  margin-top: 60px;
  border-radius: 24px;
  color: white;
  cursor: pointer;
  flex-grow: 1;
  background-color: #17224d;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  transition: transform 1.5s ease, background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: #17224d;
    transform: translateY(15%);
  }
`;

export const NotFoundButtonLink = styled.a`
  text-decoration: none;
`;

export const NotFoundText = styled.p`
  color: white;
  margin-top: 20px;
`;

export const NotFoundTitle = styled.h3`
  color: white;
`;
